import React, { useState } from 'react';

const TabbedContent = ({ tabs, onChange }: { tabs: any, onChange?: any }) => {
    const [activeTab, setActiveTab] = useState(tabs[0].name);
    const [key, setKey] = useState(0)
    const divStyle = {
        width: 235,
        height: 40,
        background: '#F6F6F6',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: '#222222',
        cursor: 'pointer',
        fontWeight: 600

    }
    const activeDivStyle = {
        width: 235,
        height: 40,
        background: '#EBEBEB',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: 14,
        color: '#666666',
        cursor: 'pointer',
        fontWeight: 'normal'
    }
    // 切换重新触发渲染
    const onChangeTab = (tab: { name: string }) => {
        setActiveTab(tab.name)
        setKey(prev => prev + 1)
        onChange && onChange(tab.name)
    }
    return (
        <div key={key}>
            <div style={{ display: 'flex', alignItems: 'center', marginTop: 12 }}>
                {tabs.map(tab => (
                    <div
                        key={tab.name}
                        style={activeTab === tab.name ? divStyle : activeDivStyle}
                        onClick={() => onChangeTab(tab)}
                    >
                        {tab.label}
                    </div>
                ))}
            </div>
            <div>
                {tabs.map(tab => (
                    <div key={tab.name} style={{ display: activeTab === tab.name ? 'block' : 'none' }}>
                        <div>{tab.content}</div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default TabbedContent;
